import { render, staticRenderFns } from "./editaddress.vue?vue&type=template&id=dff42a72&scoped=true&"
import script from "./editaddress.vue?vue&type=script&lang=js&"
export * from "./editaddress.vue?vue&type=script&lang=js&"
import style0 from "./editaddress.vue?vue&type=style&index=0&id=dff42a72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff42a72",
  null
  
)

export default component.exports